<template>
  <div class="text--primary">
    <v-row>
      <v-col cols="12" sm="6">
        <v-card outlined class="rounded-card" max-width="auto">
          <v-subheader class="text--primary">
            E-mails ativos
            <v-spacer />
            <px-fornecedor-add-email :current-fornecedor="fornecedor" @update="onUpdate">
              <template v-slot:activator="{ on }">
                <v-btn v-if="hasModuleGerencia"
                       small
                       color="primary"
                       class="normal-btn-text rounded-tag-small elevation-0"
                       v-on="on">
                  <v-icon small>
                    mdi-plus
                  </v-icon>
                    Emails
                </v-btn>
              </template>
            </px-fornecedor-add-email>
          </v-subheader>
          <v-divider />
          <px-lista-emails :has-module-gerencia="hasModuleGerencia"
                           :fornecedor="fornecedor"
                           @update="onUpdate"/>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card outlined class="rounded-card" max-width="auto">
          <v-subheader class="text--primary">
            Whatsapps ativos
            <v-spacer/>
            <px-fornecedor-add-whats :current-fornecedor="fornecedor" @update="onUpdate">
              <template v-slot:activator="{ on }">
                <v-btn v-if="hasModuleGerencia"
                       small
                       color="primary"
                       class="normal-btn-text rounded-tag-small elevation-0"
                       v-on="on">
                  <v-icon small>
                    mdi-plus
                  </v-icon>
                    Whatsapp
                </v-btn>
              </template>
            </px-fornecedor-add-whats>
          </v-subheader>
          <v-divider />
          <px-lista-whats :has-module-gerencia="hasModuleGerencia"
                          :fornecedor="fornecedor"
                          @update="onUpdate"/>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="fornecedor.user">
      <v-col cols="12">
        <v-card outlined class="rounded-card">
          <v-subheader class="text--primary">Vendedor preferencial</v-subheader>
          <v-divider/>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                {{ fornecedor.user.nome }}
                <px-ativo class="ml-2" :ativo="fornecedor.user.enabled"/>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ fornecedor.user.email }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <span class="caption font-weight-bold">Whatsapp</span>
              {{ fornecedor.user.whatsapp | phone | naoInformado }}
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FornecedorAddEmails from '../FornecedorAddEmails.vue';
import FornecedorAddWhatsapps from '../FornecedorAddWhatsapps.vue';
import ListaEmails from '../listas/ListaEmails.vue';
import ListaWhats from '../listas/ListaWhats.vue';

export default {
  props: {
    fornecedor: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
  },
  components: {
    pxFornecedorAddEmail: FornecedorAddEmails,
    pxFornecedorAddWhats: FornecedorAddWhatsapps,
    pxListaEmails: ListaEmails,
    pxListaWhats: ListaWhats,
  },
};

</script>
